module.exports = __webpack_public_path__ + "static/media/Pixoo.507346b5.png";